import React from 'react';
import Widget from 'theme/widgets';
import Spinner from 'theme/Spinner';

import Home from '_pageContainers/home';

const HomeGrid = (pageContext) => {
  const {
    props: { homeWidget, homeWidgetPending },
  } = pageContext;

  return (
    <div className='home headerMargin'>
      {homeWidgetPending && <Spinner />}
      {!homeWidgetPending &&
        homeWidget &&
        homeWidget.length > 0 &&
        homeWidget.map((widget, i) => {
          return (
            <Widget
              key={i}
              path={`home.${widget.value.widget_type}`}
              props={{
                slug: widget.value.widget_slug,
              }}
            />
          );
        })}
    </div>
  );
};

export default Home(HomeGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/home/index.js